import { EnvConfig } from '../../config/EnvConfig'
import { GamesLanguages } from '../constants'
import { getWebsiteUrl } from '../getWebsiteUrl'
import { convertOptionsToQueryParams, generateURL } from './generateURL'
import { getMockURL } from './mockURL'

const websiteURL = getWebsiteUrl()
const locale = process.env.GATSBY_INTL_LOCALE
const relaxLanguage = GamesLanguages?.relax?.[locale]

export const setRelaxURL = ({
  isLoggedIn,
  params,
  providerData,
  isMobile,
  desktopSlug,
  casinoProvider,
  isMock,
}) => {
  const isFunMode = !isLoggedIn || params?.playMode === 'FUN'

  const options = [
    {
      param: 'moneymode',
      value: isFunMode ? 'fun' : 'real',
    },
    {
      param: 'gameid',
      value: desktopSlug,
    },
    {
      param: 'jurisdiction',
      value: 'MT',
    },
    {
      param: 'partner',
      value: EnvConfig.GATSBY_KTO_RELAX_PARTNER,
    },
    {
      param: 'partnerid',
      value: EnvConfig.RELAX_PARTNER_ID,
    },
    {
      param: 'lang',
      value: relaxLanguage,
    },
    {
      param: 'channel',
      value: isMobile ? 'mobile' : 'web',
    },
    {
      param: 'ticket',
      value: providerData?.token,
    },
    {
      param: 'rcinterval',
      value: providerData?.rcInterval,
    },
    {
      param: 'rcelapsed',
      value: providerData?.rcElapsedTime,
    },
    {
      param: 'rchistoryurl',
      value: `${websiteURL}account/transactions/`,
    },
    {
      param: 'homeurl',
      value: `action:${EnvConfig.SITE_URL}`,
    },
  ]

  const baseURL = `${EnvConfig.RELAX_LAUNCH_URL}/`

  return isMock
    ? getMockURL({
        path: 'init',
        params: convertOptionsToQueryParams(options),
        casinoProvider,
      })
    : generateURL({ baseURL, options })
}
